import { ApproveDemandCompletionData } from '../../approve-demand-task/types/ApproveDemandCompletionData';
import { PurchaseRequisitionResult } from '../../../../purchase-requisition/types/PurchaseRequisitionResult';

export class PurchaseRequisitionApproveWithResultSelectionCompletionData extends ApproveDemandCompletionData {
    constructor(
        approved: boolean,
        public readonly resultsIn: PurchaseRequisitionResult,
        public readonly rework?: boolean,
        explanation?: string
    ) {
        super(approved, explanation);
    }
}
